import React, { memo, Fragment } from 'react';
import { Label, Row, Col } from 'reactstrap';
import { FormCheckbox, FormHTMLInline, FormInput } from '@core/components/form';
import { FormHTML } from '@core/components/form/FormHTML';
import { EssayDrillBlockVariation, EssayDrillForm } from './EssayDrillBlock';

export interface EssayDrillBlockSettingsProps {
  form: EssayDrillForm;
  variation: EssayDrillBlockVariation;
}

export const EssayDrillBlockSettings = memo((props: EssayDrillBlockSettingsProps) => {
  const { form, variation } = props;

  return (
    <div>
      <Fragment>
        <Row>
          <Col md={9}>
            <Label>Introduction</Label>
            <FormInput control={form.controls.stepTitle} />
            <FormHTML minimal control={form.controls.instructions} />
            <FormCheckbox control={form.controls.requireReview} />
          </Col>
        </Row>
        <hr />
      </Fragment>
    </div>
  );
});
